module.exports = __webpack_public_path__ + "img/img_app_btm_02_feature1.8e9ff538.png";